import React, { useState, useEffect } from 'react';
import './PCBDesign.css'; // For custom styles

const PCBDesign = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // Try Django API first (use relative URL for production)
        const apiUrl = process.env.REACT_APP_API_URL || '';
        console.log('Trying PCB API at:', `${apiUrl}/api/pcb-projects-json/`);
        
        const response = await fetch(`${apiUrl}/api/pcb-projects-json/`);
        if (response.ok) {
          const data = await response.json();
          console.log('PCB API data received:', data);
          setProjects(data);
          return;
        }
        throw new Error(`API error! status: ${response.status}`);
      } catch (apiError) {
        console.warn("API failed, falling back to JSON file:", apiError);
        
        try {
          // Fallback to JSON file
          const response = await fetch('/data/pcb_projects.json');
          if (response.ok) {
            const data = await response.json();
            console.log('PCB JSON fallback data received:', data);
            setProjects(data);
            return;
          }
          throw new Error(`JSON error! status: ${response.status}`);
        } catch (jsonError) {
          console.error("Both API and JSON file failed:", jsonError);
          setError('Both API and JSON file failed');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (loading) {
    return <div className="text-center py-10">Loading PCB projects...</div>;
  }

  if (error) {
    return <div className="text-center py-10 text-red-500">Error loading projects: {error}</div>;
  }

  if (projects.length === 0) {
    return <div className="text-center py-10">No PCB projects to display yet. Check back soon!</div>;
  }

  return (
    <section className="py-12 bg-transparent dark:bg-transparent">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-800 dark:text-gray-100 mb-10">PCB Design Showcase</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div key={project.id} className="bg-white dark:bg-[#0b1220] dark:text-gray-100 border border-slate-200 dark:border-[#1e3a8a] rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl flex flex-col">
              <img src={project.imageUrl} alt={project.title} className="w-full h-56 object-cover" />
              <div className="p-6 flex flex-col flex-grow">
                <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-200 mb-3">{project.title}</h2>
                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 flex-grow">{project.description}</p>
                <div className="mb-4">
                  {project.tags && project.tags.map((tag) => (
                    <span key={tag} className="inline-block bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-200 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full mb-1">
                      {tag}
                    </span>
                  ))}
                </div>
                <a 
                  href={project.detailsUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="mt-auto inline-block text-center bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-md transition-colors duration-300">
                  View Details
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PCBDesign; 
